import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";

import Breadcrumb from "../components/Breadcrumb";
import Shipping from "../components/Shipping";
import BlogDetails from "../components/BlogDetails";
import ScrollToTop from "react-scroll-to-top";
const BlogDetailsPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />


      {/* Breadcrumb */}
      <Breadcrumb title={"Blog Details"} />

      {/* BlogDetails */}
      <BlogDetails />

      {/* Shipping */}
      <Shipping />

      
    </>
  );
};

export default BlogDetailsPage;
